import { isInvitationNavigationEnabled } from "../../Utils/invitationNavigation";
import { callInvitationWatermark } from "../../Utils/invitationWatermarkApi";
import InvitationShareNotice from "../InvitationShareNotice";
import { isEmpty } from "@firebase/util";
import { useEffect, useRef, useState } from "react";
import Controller from "../Controller";
import PreviewBtn from "../PreviewBtn";
import Uploader from "../Uploder";
import "./EditInvite.css";
import { saveInvitationSettings, getDocument, auth } from "../../firebase";
import FileDisplay from "../FileDisplay";
import { getSettingsThumbnailUrl } from "../../Utils/invitationThumbnail";
import Waze from "../Waze";
import EventTimePicker, { DEFAULT_EVENT_TIME } from "../EventTimePicker";
import EventDatePicker from "../EventDatePicker";

import { DEFAULT_RSVP_OPTIONS, RSVP_OPTION_LABELS, normalizeRsvpOptions } from "../../Utils/rsvpOptions";
import {
  eventDetailsChanged,
  formatEventDateForDisplay,
  getMissingEventDetailKeys,
  getStoredEventDetails,
  hasSentEventInvitations,
  isEventDateTimeInFuture,
  isEventScheduleLocked,
  normalizeEventDetails,
} from "../../Utils/eventDetails";
import { omitUndefinedFields } from "../../Utils/firestorePayload";

import { buildInvitationSettingsPatch } from "../../Utils/invitationSettingsPatch";
import { getInvitationEditorAvailability, openInvitationEditor } from "../../Utils/invitationEditingApi";

const UPLOADCARE_PUB_KEY = "4af1fec857788003f2a8";

const additionalOptionDescriptions = {
  transportation: "שאלת כן/לא ומספר מקומות בהסעה",
  vegetarian: "בחירה אופציונלית לכל אורח",
  vegan: "בחירה אופציונלית לכל אורח",
  glattKosher: "בחירה אופציונלית לכל אורח",
  glutenFree: "בחירה אופציונלית לכל אורח",
  childMeal: "בחירה אופציונלית לכל אורח",
  gender: "כאשר פעיל, חובה לבחור גבר או אישה לכל אורח",
};

const extractUploadcareUUID = (url = "") => {
  const match = String(url || "").match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
  return match ? match[1] : null;
};


const { createPreviewVersion } = require("../../firebase/functions/invitationPreviewVersion");

const EditInvite = ({ addAlertText, docID, isReadOnly = false }) => {
  const showLegacyInvitationFields = false;
  const [openingEditor, setOpeningEditor] = useState(false);
  const [editorEligibility, setEditorEligibility] = useState({ eventId: "", available: false });
  const canEditDesigner = editorEligibility.eventId === docID && editorEligibility.available && !isReadOnly;
  useEffect(() => {
    let active = true;
    setEditorEligibility({ eventId: docID, available: false });
    if (docID && !isReadOnly) getInvitationEditorAvailability(docID).then(available => {
      if (active) setEditorEligibility({ eventId: docID, available });
    }).catch(() => { /* Unverified eligibility never shows an editing action. */ });
    return () => { active = false; };
  }, [docID, isReadOnly]);
  const editorOpening = useRef(false);
  useEffect(() => {
    const restoreAfterBack = (event) => {
      if (event.persisted) { editorOpening.current = false; setOpeningEditor(false); }
    };
    window.addEventListener("pageshow", restoreAfterBack);
    return () => window.removeEventListener("pageshow", restoreAfterBack);
  }, []);
  const [attachmentRemoved, setAttachmentRemoved] = useState(false);
  const removeAttachment = () => { setAttachmentRemoved(true); setExternalSource({}); setAttachmentUrl(""); };
  const editDesignerInvitation = async () => {
    if (editorOpening.current || !canEditDesigner) return;
    editorOpening.current = true;
    setOpeningEditor(true);
    let editorUrl;
    try {
      editorUrl = await openInvitationEditor(docID);
      window.location.assign(editorUrl);
      // Navigation is asynchronous: keep the spinner and click guard until this page leaves.
    } catch (error) {
      editorOpening.current = false;
      setOpeningEditor(false);
      if (!editorUrl) setEditorEligibility({ eventId: docID, available: false });
      addAlertText({ text: error.message, mode: "warning" });
    }
  };
  const [namesFontSize, setNamesFontSize] = useState("50");
  const [namesColor, setNamesColor] = useState("#D3AF37");
  const [quouteFontSize, setQuouteFontSize] = useState("28");
  const [quouteColor, setQuouteColor] = useState("#D3AF37");
  const [dateFontSize, setDateFontSize] = useState("50");
  const [dateColor, setDateColor] = useState("#D3AF37");
  const [addressFontSize, setAddressFontSize] = useState("20");
  const [addressColor, setAddressColor] = useState("#D3AF37");
  const [parentsFontSize, setParentsFontSize] = useState("24");
  const [parentsColor, setParentsColor] = useState("#D3AF37");
  const [backgroundColor, setBackgroundColor] = useState("#FFFEFC");
  const [borderColor, setBorderColor] = useState("#263F3F");
  const [externalSource, setExternalSource] = useState({});
  const [submit, setSubmit] = useState(false);
  const [eventOwners, seteventOwners] = useState("כותרת האירוע שלכם!");
  const [dedicationText, setDedicationText] = useState("טקסט טקסט טקסט  ");
  const [date, setDate] = useState("27.08.22");
  const [day, setDay] = useState("יום חמישי");

  const [locationName, setLocationName] = useState(" אולמי השרון");
  const [locationAddress, setLocationAddress] = useState("רחוב החלוצים 5 רעננה");
  const [brideParentsLabel, setBrideParentsLabel] = useState("אחים");
  const [groomParentsLabel, setGroomParentsLabel] = useState("הורים");
  const [brideParentsNames, setBrideParentsNames] = useState("יצחק ורבקה ימיני");
  const [groomParentsNames, setGroomParentsNames] = useState(" יעקב ורחל ישראלי");
  const [dedicationSecond, setdedicationSecond] = useState(" נשמח לראותכם!");
  const [previewMode, setPreviewMode] = useState(false);
  const [watermarkManaged,setWatermarkManaged] = useState(false);
  const [watermarkPreparing,setWatermarkPreparing] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [attachmentType, setAttachmentType] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [navigationPreference, setWithWazeLink] = useState(undefined);
  const withWazeLink = isInvitationNavigationEnabled({ withWazeLink: navigationPreference, locationAddress });
  const [showConfetti, setShowConfetti] = useState(true);
  const [additionalRsvpOptions, setAdditionalRsvpOptions] = useState(DEFAULT_RSVP_OPTIONS);
  const [pendingOptionDisable, setPendingOptionDisable] = useState(null);
  const [hasFutureWhatsAppMessages, setHasFutureWhatsAppMessages] = useState(false);
  const [eventTitle, setEventTitle] = useState("");
  const [savedEventTitle, setSavedEventTitle] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [savedEventDetails, setSavedEventDetails] = useState({ date: "", time: "", venueName: "", address: "" });
  const [hasSentInvitations, setHasSentInvitations] = useState(false);
  const [showEventDetailsChangeWarning, setShowEventDetailsChangeWarning] = useState(false);
  const [eventDetailsChangeConfirmed, setEventDetailsChangeConfirmed] = useState(false);
  const [eventScheduleLocked, setEventScheduleLocked] = useState(false);
  const [invitationLinkVersion, setInvitationLinkVersion] = useState("");
  const [originalInvitationData, setOriginalInvitationData] = useState({});
  const [openSections, setOpenSections] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return { title: false, file: params.get("tab") === "edit" && params.get("section") === "file", waze: false, rsvpOptions: false, display: false };
  });
  const [showShareLinkModal, setShowShareLinkModal] = useState(false);
  const [showShareExplanation, setShowShareExplanation] = useState(false);
  const [showContentHelpModal, setShowContentHelpModal] = useState(false);

  const handleUploadFromModal = (sourceData) => {
    setAttachmentRemoved(false);
    setExternalSource(sourceData);
    setAttachmentUrl(sourceData.result);
    setAttachmentType(sourceData.fileType);
    setShowUploadModal(false);
  };
  const [namesCols, setNamesCols] = useState(1);
  const [dedicationCols, setDedicationCols] = useState(1);
  const [dateCols, setDateCols] = useState(1);
  const [dayCols, setDayCols] = useState(1);
  const [loctionNameCols, setLoctionNameCols] = useState(1);
  const [LocationAddressCols, setLocationAddressCols] = useState(1);
  const [groomLabelCols, setgroomLabelCols] = useState(1);
  const [brideLabelCols, setBrideLabelCols] = useState(1);
  const [brideParentsNamesCols, setbrideParentsNamesCols] = useState(1);
  const [groomParentsNamesCols, setgroomParentsCols] = useState(1);
  const [dedicationSecondCols, setdedicationSecondCols] = useState(1);

  useEffect(() => {
    const fireAsync = async () => {
      let doc = await getDocument({ docID: docID });
      let data = doc.data();
      setWatermarkManaged(data.invitationDelivery?.deliveryMode === "FREE_WATERMARK");
      setWatermarkPreparing(data.invitationDelivery?.preparing === true);
      console.log(data);
      if (data.hasOwnProperty("invitationData")) {
        const invitationData = data.invitationData;
        setOriginalInvitationData(invitationData);
        setNamesFontSize(invitationData.namesFontSize);
        setNamesColor(invitationData.namesColor);
        setQuouteFontSize(invitationData.quouteFontSize);
        setQuouteColor(invitationData.quouteColor);
        setDateFontSize(invitationData.dateFontSize);
        setDateColor(invitationData.dateColor);
        setAddressFontSize(invitationData.addressFontSize);
        setAddressColor(invitationData.addressColor);
        setParentsFontSize(invitationData.parentsFontSize);
        setParentsColor(invitationData.parentsColor);
        setBackgroundColor(invitationData.backgroundColor);
        setBorderColor(invitationData.borderColor);
        seteventOwners(`${invitationData.eventOwners}`);
        setDedicationText(invitationData.dedicationText);
        setDate(invitationData.date);
        setDay(invitationData.day);
        setLocationName(invitationData.locationName);
        setLocationAddress(invitationData.locationAddress);
        setBrideParentsLabel(invitationData.brideParentsLabel);
        setGroomParentsLabel(invitationData.groomParentsLabel);
        setBrideParentsNames(invitationData.brideParentsNames);
        setGroomParentsNames(invitationData.groomParentsNames);
        setdedicationSecond(invitationData.dedicationSecond);
        setWithWazeLink(typeof invitationData.withWazeLink === "boolean" ? invitationData.withWazeLink : undefined);
        setShowConfetti(invitationData.showConfetti !== false);
        setAdditionalRsvpOptions(normalizeRsvpOptions(invitationData.additionalRsvpOptions));
        setBrideLabelCols(invitationData.brideLabelCols);
        setbrideParentsNamesCols(invitationData.brideParentsNamesCols);
        setdedicationSecondCols(invitationData.dedicationCols);
        if (data.invitationDelivery?.deliveryMode === "FREE_WATERMARK") {
          // FREE: start from the published display image (watermarked, or none while it is prepared).
          setAttachmentUrl(data.invitationDelivery.url || "");
          setAttachmentType(data.invitationDelivery.fileType || invitationData.attachmentData?.fileType || "");
        } else if (invitationData.hasOwnProperty("attachmentData")) {
          setAttachmentUrl(invitationData.attachmentData.url);
          setAttachmentType(invitationData.attachmentData.fileType);
        }
      }
      const loadedEventDetails = getStoredEventDetails(data);
      setEventTitle(loadedEventDetails.title);
      setSavedEventTitle(loadedEventDetails.title);
      setEventDate(loadedEventDetails.date);
      setEventTime(loadedEventDetails.time || DEFAULT_EVENT_TIME);
      setLocationName(loadedEventDetails.venueName);
      setLocationAddress(loadedEventDetails.address);
      setSavedEventDetails({
        date: loadedEventDetails.date,
        time: loadedEventDetails.time,
        venueName: loadedEventDetails.venueName,
        address: loadedEventDetails.address,
      });
      setHasSentInvitations(hasSentEventInvitations(data.messages));
      setEventScheduleLocked(isEventScheduleLocked(data));
      setInvitationLinkVersion(
        data.invitationLinkVersion || extractUploadcareUUID(data.invitationData?.attachmentData?.url) || ""
      );
      const futureWhatsAppMessages = (data.messages || []).some((message) =>
        message.status !== "cancelled" &&
        message.status !== "error" &&
        message.channel === "whatsapp" &&
        new Date(String(message.timeToSend || "").replace(" ", "T")).getTime() > Date.now()
      );
      setHasFutureWhatsAppMessages(futureWhatsAppMessages);

      return doc;
    };
    if (docID) {
      fireAsync();
    }
  }, [docID]);

  useEffect(() => {
    if (submit) {
      const normalizedTitle = eventTitle.trim();
      const normalizedDetails = normalizeEventDetails({
        title: normalizedTitle,
        date: eventDate,
        time: eventTime,
        venueName: locationName,
        address: locationAddress,
      });
      if (!normalizedTitle) {
        addAlertText({ text: "יש להזין כותרת לאירוע.", mode: "warning" });
        setSubmit(false);
        return;
      }
      if (getMissingEventDetailKeys(normalizedDetails).length > 0) {
        addAlertText({ text: "יש להשלים את כל פרטי האירוע.", mode: "warning" });
        setSubmit(false);
        return;
      }
      if (!isEventDateTimeInFuture(normalizedDetails)) {
        addAlertText({ text: "יש לבחור תאריך ושעה עתידיים לאירוע.", mode: "warning" });
        setSubmit(false);
        return;
      }
      if (additionalRsvpOptions.transportation?.enabled && typeof additionalRsvpOptions.transportation.required !== "boolean") {
        addAlertText({ text: "יש לבחור אם שאלת ההסעה היא חובה או רשות.", mode: "warning" });
        setSubmit(false);
        return;
      }
      if (
        additionalRsvpOptions.transportation?.enabled &&
        !String(additionalRsvpOptions.transportation.departureDetails || "").trim()
      ) {
        addAlertText({ text: "יש למלא כתובת ושעת יציאה להסעה.", mode: "warning" });
        setSubmit(false);
        return;
      }

      const criticalDetailsChanged = eventDetailsChanged(normalizedDetails, savedEventDetails);
      if (hasSentInvitations && criticalDetailsChanged && !eventDetailsChangeConfirmed) {
        setShowEventDetailsChangeWarning(true);
        setSubmit(false);
        return;
      }

      const publicEventDate = formatEventDateForDisplay(normalizedDetails.date);
      const publicEventTime = `בשעה ${normalizedDetails.time}`;
      const payload = {
        title: normalizedTitle,
        eventDetails: {
          date: normalizedDetails.date,
          time: normalizedDetails.time,
          venueName: normalizedDetails.venueName,
          address: normalizedDetails.address,
        },
        invitationData: omitUndefinedFields({

          eventOwners: normalizedTitle !== savedEventTitle ? normalizedTitle : eventOwners,
          dedicationSecond,
          dedicationText,
          date: publicEventDate,
          day: publicEventTime,
          locationAddress: normalizedDetails.address,
          locationName: normalizedDetails.venueName,
          brideParentsLabel,
          brideParentsNames,
          groomParentsLabel,
          groomParentsNames,
          namesFontSize,
          namesColor,
          quouteFontSize,
          quouteColor,
          dateFontSize,
          dateColor,
          addressFontSize,
          addressColor,
          parentsFontSize,
          parentsColor,
          backgroundColor,
          borderColor,
          withWazeLink: navigationPreference,
          showConfetti,
          additionalRsvpOptions: normalizeRsvpOptions(additionalRsvpOptions),
        }),
      };

      const fireAsync = async () => {
        if (attachmentRemoved && hasFutureWhatsAppMessages && isEmpty(externalSource)) {
          addAlertText({
            text: "יש הודעות וואטסאפ מתוזמנות. אם תמחקו את תמונת ההזמנה, ההודעות לא יישלחו.",
            mode: "warning",
          });
          setSubmit(false);
          return;
        }
        const titleChanged = normalizedTitle !== savedEventTitle;
        const selectedNewFile = !isEmpty(externalSource);
        let nextAttachmentUrl = attachmentUrl;

        if (selectedNewFile) {
          const formData = new FormData();
          formData.append("UPLOADCARE_PUB_KEY", UPLOADCARE_PUB_KEY);
          formData.append("UPLOADCARE_STORE", "1");
          formData.append("file", externalSource.file);
          const res = await fetch("https://upload.uploadcare.com/base/", { method: "POST", body: formData });
          if (!res.ok) throw new Error("Uploadcare upload failed");
          const data = await res.json();
          const url = `https://ucarecdn.com/${data.file}/`;
          nextAttachmentUrl = url;
          payload.invitationData.attachmentData = {
            url,
            fileType: externalSource.fileType,
          };
        }
        if (!selectedNewFile && attachmentRemoved) {
          payload.invitationData.attachmentData = {
            url: attachmentUrl,
            fileType: attachmentType,
          };
        }
        const imageChanged = selectedNewFile || attachmentRemoved;
        const previewChanged = titleChanged || imageChanged;
        const nextVersion = previewChanged ? createPreviewVersion() : invitationLinkVersion;
        if (previewChanged) payload.invitationLinkVersion = nextVersion;

        const patch = buildInvitationSettingsPatch({ payload, originalInvitationData,
          attachmentAction: selectedNewFile ? "replace" : attachmentRemoved ? "remove" : "unchanged" });
        const current = await saveInvitationSettings({ docID, patch });
        // FREE: show only the published display image (none until the watermark is ready).
        if (current.invitationDelivery?.deliveryMode === "FREE_WATERMARK") nextAttachmentUrl = current.invitationDelivery.url || "";
        else if (!imageChanged) nextAttachmentUrl = current.invitationData?.attachmentData?.url || "";
        setWatermarkManaged(current.invitationDelivery?.deliveryMode === "FREE_WATERMARK");
        setWatermarkPreparing(current.invitationDelivery?.preparing === true);
        const currentVersion = current.invitationLinkVersion || "";
        setEventTitle(normalizedTitle);
        setSavedEventTitle(normalizedTitle);
        setEventDate(normalizedDetails.date);
        setEventTime(normalizedDetails.time);
        setDate(publicEventDate);
        setDay(publicEventTime);
        if (normalizedTitle !== savedEventTitle) seteventOwners(normalizedTitle);
        setLocationName(normalizedDetails.venueName);
        setLocationAddress(normalizedDetails.address);
        setSavedEventDetails({
          date: normalizedDetails.date,
          time: normalizedDetails.time,
          venueName: normalizedDetails.venueName,
          address: normalizedDetails.address,
        });
        setAttachmentUrl(nextAttachmentUrl);
        setAttachmentType(current.invitationData?.attachmentData?.fileType || "");
        setOriginalInvitationData({ ...originalInvitationData, ...payload.invitationData, attachmentData: current.invitationData?.attachmentData });
        setAttachmentRemoved(false);
        setInvitationLinkVersion(currentVersion);
        setExternalSource({});
        if (previewChanged && !current.invitationDelivery?.preparing) {
          setInvitationLinkVersion(current.invitationDelivery ? currentVersion : nextVersion);
          setShowShareExplanation(false);
          setShowShareLinkModal(true);
        }
        addAlertText({ text: "השינויים נשמרו בהצלחה.", mode: "success" });
        if (hasSentInvitations && titleChanged && !criticalDetailsChanged) {
          addAlertText({
            text: "שימו לב: נשלחו כבר הזמנות עם כותרת האירוע הקודמת.",
            mode: "warning",
          });
        }
        setEventDetailsChangeConfirmed(false);
        setSubmit(false);
      };

      fireAsync().catch(() => {
        addAlertText({ text: "לא הצלחנו לשמור את השינויים. נסו שוב.", mode: "danger" });
        setEventDetailsChangeConfirmed(false);
        setSubmit(false);
      });
    }
  }, [submit]);

  useEffect(() => {
    if (!showShareLinkModal && !showContentHelpModal) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setShowShareLinkModal(false);
        setShowContentHelpModal(false);
      }
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [showShareLinkModal, showContentHelpModal]);

  useEffect(()=>{
    if(!watermarkManaged || !openSections.file)return undefined;
    let active=true,timer;
    const poll=async()=>{
      let nextDelay=watermarkPreparing ? 1500 : 10000;
      try {
        const idToken=await auth?.currentUser?.getIdToken();
        if(!idToken)return;
        const current=await callInvitationWatermark({idToken,eventId:docID,action:"inspect"});
        if(!active)return;
        setWatermarkPreparing(current.preparing === true);
        nextDelay=current.status === "FAILED" ? 5000 : current.preparing ? 1500 : 10000;
        // Never replace the user's unsaved replacement/removal draft.
        if(!attachmentRemoved && !externalSource.file && !externalSource.url){
          setAttachmentUrl(current.imageUrl || "");
          setAttachmentType(current.fileType || "image/jpeg");
          if(current.invitationLinkVersion && current.invitationLinkVersion !== invitationLinkVersion){
            setInvitationLinkVersion(current.invitationLinkVersion);
            if(!current.preparing){setShowShareExplanation(false);setShowShareLinkModal(true);}
          }
        }
      }catch(_error) {/* Preserve the displayed image and retry metadata; no uploads here. */}
      finally {if(active)timer=setTimeout(poll,nextDelay);}
    };
    poll();
    return()=>{active=false;clearTimeout(timer);};
  },[docID,watermarkManaged,openSections.file,watermarkPreparing,attachmentRemoved,externalSource,invitationLinkVersion]);
  const toggleSection = (section, event) => {
    const sectionCard = event.currentTarget.closest(".invite-editor__dropdown-card");
    const willOpen = !openSections[section];
    setOpenSections((current) => ({ ...current, [section]: !current[section] }));
    if (willOpen && sectionCard) {
      window.setTimeout(() => {
        sectionCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 80);
    }
  };

  const setRsvpOptionEnabled = (key, enabled) => {
    const wasSavedAsEnabled = normalizeRsvpOptions(originalInvitationData.additionalRsvpOptions)[key]?.enabled;
    if (!enabled && wasSavedAsEnabled) {
      setPendingOptionDisable(key);
      return;
    }
    setAdditionalRsvpOptions((current) => ({
      ...normalizeRsvpOptions(current),
      [key]: { ...normalizeRsvpOptions(current)[key], enabled },
    }));
  };

  const confirmDisableRsvpOption = () => {
    if (!pendingOptionDisable) return;
    setAdditionalRsvpOptions((current) => ({
      ...normalizeRsvpOptions(current),
      [pendingOptionDisable]: { ...normalizeRsvpOptions(current)[pendingOptionDisable], enabled: false },
    }));
    setPendingOptionDisable(null);
  };

  const confirmEventDetailsChange = () => {
    setShowEventDetailsChangeWarning(false);
    setEventDetailsChangeConfirmed(true);
    setSubmit(true);
  };

  useEffect(() => {
    function autoResize() {
      this.style.height = "auto";
      this.style.height = this.scrollHeight + "px";
    }
    let texts = document.querySelectorAll("textarea");
    texts.forEach((el) => {
      el.addEventListener("input", autoResize, false);
    });

    return () => {
      texts.forEach((el) => {
        el.removeEventListener("input", () => {}, false);
      });
    };
  }, []);

  if (!showLegacyInvitationFields) {
    return (
      <main className="invite-editor" dir="rtl">
        <header className="invite-editor__header">
          <div>
            <span className="invite-editor__eyebrow">הזמנה דיגיטלית וניווט</span>
            <h1>הגדרות הזמנה</h1>
          </div>
        </header>
        <div className="invite-editor__sticky-save">
          <PreviewBtn submit={submit} setSubmit={setSubmit} isReadOnly={isReadOnly} />
        </div>

        <div className="invite-editor__workspace">
          <aside className="invite-editor__controls">
            <section className="invite-editor__card invite-editor__dropdown-card">
              <button
                type="button"
                className="invite-editor__dropdown-toggle"
                aria-expanded={openSections.title}
                aria-controls="event-details-settings"
                onClick={(event) => toggleSection("title", event)}
              >
                <span className="invite-editor__step">1</span>
                <span className="invite-editor__dropdown-label">עריכת פרטי האירוע</span>
                <span className={`invite-editor__dropdown-arrow ${openSections.title ? "invite-editor__dropdown-arrow--open" : ""}`} aria-hidden="true">▼</span>
              </button>
              {openSections.title && (
                <div id="event-details-settings" className="invite-editor__dropdown-content">
                  <label htmlFor="event-title">כותרת האירוע</label>
                  <input
                    id="event-title"
                    type="text"
                    className="form-control"
                    value={eventTitle}
                    maxLength={120}
                    disabled={isReadOnly}
                    placeholder="לדוגמא: החתונה של מיכל ואיתן"
                    onChange={(event) => setEventTitle(event.target.value)}
                  />
                  <div className="invite-editor__event-details-row">
                    <label htmlFor="event-date" className="invite-editor__event-date-field">
                      <span>תאריך האירוע</span>
                      <EventDatePicker
                        id="event-date"
                        value={eventDate}
                        disabled={isReadOnly || eventScheduleLocked}
                        onChange={setEventDate}
                      />
                    </label>
                    <div className="invite-editor__event-time-field">
                      <span>שעת האירוע</span>
                      <EventTimePicker
                        value={eventTime}
                        disabled={isReadOnly || eventScheduleLocked}
                        onChange={setEventTime}
                        idPrefix="event-time"
                      />
                      <small>בחירה בפורמט 24 שעות.</small>
                    </div>
                  </div>
                  {eventScheduleLocked && (
                    <div className="invite-editor__event-schedule-lock" role="status">
                      לא ניתן לשנות את תאריך או שעת האירוע לאחר הפעלת טייס אוטומטי. לשינוי יש לפנות לשירות הלקוחות.
                    </div>
                  )}

                  <label htmlFor="event-venue-name">שם מקום האירוע</label>
                  <input
                    id="event-venue-name"
                    type="text"
                    className="form-control"
                    value={locationName}
                    maxLength={160}
                    disabled={isReadOnly}
                    placeholder="לדוגמה: גן האירועים הטירה"
                    onChange={(event) => setLocationName(event.target.value)}
                  />

                  <label htmlFor="event-address">כתובת האירוע</label>
                  <input
                    id="event-address"
                    type="text"
                    className="form-control"
                    value={locationAddress}
                    maxLength={300}
                    disabled={isReadOnly}
                    placeholder="עיר, רחוב ומספר"
                    onChange={(event) => setLocationAddress(event.target.value)}
                  />
                  <small>הכתובת משמשת גם לניווט ב־Waze כאשר אפשרות הניווט פעילה.</small>
                </div>
              )}
            </section>

            <section className="invite-editor__card invite-editor__dropdown-card">
              <button
                type="button"
                className="invite-editor__dropdown-toggle"
                aria-expanded={openSections.file}
                aria-controls="invitation-file-settings"
                onClick={(event) => toggleSection("file", event)}
              >
                <span className="invite-editor__step">2</span>
                <span className="invite-editor__dropdown-label">שינוי קובץ הזמנה</span>
                <span className={`invite-editor__dropdown-arrow ${openSections.file ? "invite-editor__dropdown-arrow--open" : ""}`} aria-hidden="true">▼</span>
              </button>
              {openSections.file && (
                <div id="invitation-file-settings" className="invite-editor__dropdown-content">
                  <div className="invite-editor__inline-preview">
                    <div className="invite-editor__preview-heading">
                      <div>
                        <span>ההזמנה הנוכחית</span>
                        <small>תצוגה מקדימה של הקובץ הפעיל</small>
                      </div>
                      {attachmentUrl && <span className="invite-editor__live-badge">פעיל</span>}
                    </div>
                    <div className="invite-editor__preview-frame invite-editor__preview-frame--compact">
                      {attachmentUrl || watermarkPreparing ? (
                        <FileDisplay
                          preparing={watermarkPreparing}
                          source={getSettingsThumbnailUrl(attachmentUrl, attachmentType)}
                          localState={attachmentType}
                          setSource={removeAttachment}
                          withButton={false}
                        />
                      ) : (
                        <div className="invite-editor__empty-preview">
                          <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="3" /><path d="m7 15 3-3 3 3 2-2 3 3" /><circle cx="16" cy="9" r="1.5" /></svg>
                          <strong>לא נבחר קובץ הזמנה</strong>
                          <span>בחרו קובץ כדי לראות אותו כאן.</span>
                        </div>
                      )}
                    </div>
                  </div>
                  {canEditDesigner && <button type="button" className="invite-save-button invite-editor__designer-button" disabled={isReadOnly || openingEditor} aria-busy={openingEditor} onClick={editDesignerInvitation}>
                    {openingEditor && <span className="spinner-border spinner-border-sm" aria-hidden="true" />}
                    <span>עריכת הזמנה</span>
                  </button>}
                  {attachmentUrl ? (
                    <div className="invite-editor__file-controls">
                      <div className="invite-editor__file-status">
                        <span aria-hidden="true">✓</span>
                        קובץ הזמנה פעיל
                      </div>
                      <button type="button" className="btn btn-outline-primary" disabled={isReadOnly} onClick={() => setShowUploadModal(true)}>
                        החלפת קובץ
                      </button>
                      <button type="button" className="btn btn-outline-secondary" disabled={isReadOnly} onClick={removeAttachment}>הסרת קובץ</button>
                      <button
                        type="button"
                        className="invite-editor__content-help-button"
                        onClick={() => setShowContentHelpModal(true)}
                      >
                        שינוי תוכן ההזמנה
                      </button>
                    </div>
                  ) : (
                    <Uploader
                      withFile={false}
                      addAlertText={addAlertText}
                      setExternalSource={handleUploadFromModal}
                      externalSource={externalSource}
                    />
                  )}
                </div>
              )}
            </section>

            <section className="invite-editor__card invite-editor__dropdown-card">
              <button
                type="button"
                className="invite-editor__dropdown-toggle"
                aria-expanded={openSections.waze}
                aria-controls="waze-settings"
                onClick={(event) => toggleSection("waze", event)}
              >
                <span className="invite-editor__step">4</span>
                <span className="invite-editor__dropdown-label">ניווט לאירוע</span>
                <span className={`invite-editor__dropdown-arrow ${openSections.waze ? "invite-editor__dropdown-arrow--open" : ""}`} aria-hidden="true">▼</span>
              </button>
              {openSections.waze && (
                <div id="waze-settings" className="invite-editor__dropdown-content">
                  <p className="invite-editor__dropdown-description">הפעילו ניווט לכתובת האירוע השמורה בפרטי האירוע.</p>
                  <Waze
                    withWazeLink={withWazeLink}
                    setWithWazeLink={setWithWazeLink}
                    disabled={previewMode}
                    demoAllow={isReadOnly}
                  />
                </div>
              )}
            </section>

            <section className="invite-editor__card invite-editor__dropdown-card">
              <button
                type="button"
                className="invite-editor__dropdown-toggle"
                aria-expanded={openSections.rsvpOptions}
                aria-controls="additional-rsvp-settings"
                onClick={(event) => toggleSection("rsvpOptions", event)}
              >
                <span className="invite-editor__step">3</span>
                <span className="invite-editor__dropdown-label">אופציות לשאלות נוספות לאורחים</span>
                <span className={`invite-editor__dropdown-arrow ${openSections.rsvpOptions ? "invite-editor__dropdown-arrow--open" : ""}`} aria-hidden="true">▼</span>
              </button>
              {openSections.rsvpOptions && (
                <div id="additional-rsvp-settings" className="invite-editor__dropdown-content">
                  <p className="invite-editor__dropdown-description">הפעילו את השאלות הנוספות שתרצו להציג לאורח באישור ההגעה</p>
                  <div className="invite-editor__rsvp-warning" role="note">
                    <span className="invite-editor__rsvp-warning-icon" aria-hidden="true">
                      <svg viewBox="0 0 28 25">
                        <path d="M14 2 26 23H2L14 2Z" />
                        <path d="M14 8v7" />
                        <circle cx="14" cy="19" r="1" />
                      </svg>
                    </span>
                    <p>
                      רצוי להשתמש בשאלות האלו כמה שפחות.
                      <br />
                      עדיף באירוע קטן <strong>לא להשתמש כלל</strong> ולשאול את האורחים באופן אישי.
                      <br />
                      יותר מידי שאלות יגרמו לאורח לנטוש את אישור ההגעה
                    </p>
                  </div>
                  <div className="rsvp-settings-list">
                    {Object.keys(DEFAULT_RSVP_OPTIONS).map((key) => {
                      const option = normalizeRsvpOptions(additionalRsvpOptions)[key];
                      return (
                        <div className="rsvp-settings-option" key={key}>
                          <label className={`waze-smart-toggle ${isReadOnly ? "waze-smart-toggle--disabled" : ""}`}>
                            <span className="waze-smart-toggle__icon" aria-hidden="true">✓</span>
                            <span className="waze-smart-toggle__text">
                              <strong>{RSVP_OPTION_LABELS[key]}</strong>
                              <small>{additionalOptionDescriptions[key]}</small>
                            </span>
                            <input
                              type="checkbox"
                              checked={option.enabled}
                              disabled={isReadOnly}
                              data-demo-allow={isReadOnly ? "true" : undefined}
                              onChange={(event) => setRsvpOptionEnabled(key, event.target.checked)}
                            />
                            <span className="waze-smart-toggle__switch" aria-hidden="true" />
                          </label>
                          {key === "transportation" && option.enabled && (
                            <>
                              <fieldset className="rsvp-settings-required">
                                <legend>האם האורח חייב לענות?</legend>
                                <label>
                                  <input
                                    type="radio"
                                    name="transportation-required"
                                    checked={option.required === true}
                                    disabled={isReadOnly}
                                    onChange={() => setAdditionalRsvpOptions((current) => ({
                                      ...normalizeRsvpOptions(current),
                                      transportation: { ...normalizeRsvpOptions(current).transportation, required: true },
                                    }))}
                                  />
                                  חובה
                                </label>
                                <label>
                                  <input
                                    type="radio"
                                    name="transportation-required"
                                    checked={option.required === false}
                                    disabled={isReadOnly}
                                    onChange={() => setAdditionalRsvpOptions((current) => ({
                                      ...normalizeRsvpOptions(current),
                                      transportation: { ...normalizeRsvpOptions(current).transportation, required: false },
                                    }))}
                                  />
                                  רשות
                                </label>
                              </fieldset>
                              <label className="rsvp-settings-transportation-details">
                                <strong>כתובת ושעת יציאת ההסעה</strong>
                                <input
                                  type="text"
                                  value={option.departureDetails || ""}
                                  maxLength={180}
                                  required
                                  disabled={isReadOnly}
                                  placeholder="לדוגמה: שדרות רבין 11 נתניה בשעה 19:00"
                                  onChange={(event) => setAdditionalRsvpOptions((current) => ({
                                    ...normalizeRsvpOptions(current),
                                    transportation: {
                                      ...normalizeRsvpOptions(current).transportation,
                                      departureDetails: event.target.value,
                                    },
                                  }))}
                                />
                                <small>הפרטים יוצגו אוטומטית בתזכורת למוזמנים שביקשו הסעה.</small>
                              </label>
                            </>
                          )}
                          {key === "transportation" && option.enabled && typeof option.required !== "boolean" && (
                            <small className="rsvp-settings-required-note">יש לבחור חובה או רשות לפני שמירת השינויים.</small>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </section>

            <section className="invite-editor__card invite-editor__dropdown-card">
              <button
                type="button"
                className="invite-editor__dropdown-toggle"
                aria-expanded={openSections.display}
                aria-controls="invitation-display-settings"
                onClick={(event) => toggleSection("display", event)}
              >
                <span className="invite-editor__step">5</span>
                <span className="invite-editor__dropdown-label">הגדרות תצוגת הזמנה</span>
                <span className={`invite-editor__dropdown-arrow ${openSections.display ? "invite-editor__dropdown-arrow--open" : ""}`} aria-hidden="true">▼</span>
              </button>
              {openSections.display && (
                <div id="invitation-display-settings" className="invite-editor__dropdown-content">
                  <p className="invite-editor__dropdown-description">בחירת אפקטים שיוצגו לאורחים בהזמנה.</p>
                  <label className={`waze-smart-toggle ${isReadOnly ? "waze-smart-toggle--disabled" : ""}`}>
                    <span className="waze-smart-toggle__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24"><path d="M6 4v3M4.5 5.5h3M18 5v3M16.5 6.5h3M8 16v3M6.5 17.5h3M16 14v4M14 16h4" /></svg>
                    </span>
                    <span className="waze-smart-toggle__text">
                      <strong>קונפטי</strong>
                      <small>הצגת קונפטי מונפש על ההזמנה</small>
                    </span>
                    <input
                      type="checkbox"
                      checked={showConfetti}
                      disabled={isReadOnly}
                      data-demo-allow={isReadOnly ? "true" : undefined}
                      onChange={(event) => setShowConfetti(event.target.checked)}
                    />
                    <span className="waze-smart-toggle__switch" aria-hidden="true" />
                  </label>
                </div>
              )}
            </section>

            <div className="invite-editor__save-note">
              <span aria-hidden="true">ℹ</span>
              לאחר כל שינוי לחצו על “שמירת שינויים” בראש המסך.
            </div>
          </aside>

          <div className="invite-editor__save-note invite-editor__save-note--mobile">
            <span aria-hidden="true">ℹ</span>
            לאחר כל שינוי לחצו על “שמירת שינויים” בראש המסך.
          </div>
        </div>

        {showUploadModal && (
          <div className="upload-modal-backdrop" onClick={(event) => { if (event.target === event.currentTarget) setShowUploadModal(false); }}>
            <div className="upload-modal-box">
              <button type="button" className="btn-close upload-modal-close" aria-label="סגירה" onClick={() => setShowUploadModal(false)} />
              <div className="text-center fw-bold fs-5 mb-3">בחירת קובץ חדש להזמנה</div>
              <Uploader
                withFile={false}
                addAlertText={addAlertText}
                setExternalSource={handleUploadFromModal}
                externalSource={externalSource}
              />
            </div>
          </div>
        )}

        {pendingOptionDisable && (
          <div className="rsvp-option-modal" role="presentation">
            <section className="rsvp-option-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="rsvp-option-disable-title">
              <h2 id="rsvp-option-disable-title">כיבוי {RSVP_OPTION_LABELS[pendingOptionDisable]}</h2>
              <p>
                כיבוי האפשרות יסתיר אותה מהאורחים והמערכת לא תתייחס אליה כאפשרות פעילה. הבחירות שכבר נשמרו לא יימחקו. אם תפעילו את האפשרות מחדש, כל הבחירות הקודמות יישמרו ויוצגו שוב.
              </p>
              <div className="rsvp-option-modal__actions">
                <button type="button" className="btn btn-outline-secondary" onClick={() => setPendingOptionDisable(null)}>ביטול</button>
                <button type="button" className="btn btn-danger" onClick={confirmDisableRsvpOption}>כיבוי האפשרות</button>
              </div>
            </section>
          </div>
        )}

        {showEventDetailsChangeWarning && (
          <div className="rsvp-option-modal" role="presentation">
            <section
              className="rsvp-option-modal__dialog event-details-warning-dialog"
              role="alertdialog"
              aria-modal="true"
              aria-labelledby="event-details-change-warning-title"
            >
              <h2 id="event-details-change-warning-title">זהירות</h2>
              <p>זהירות: נשלחו כבר הזמנות עם הפרטים הקודמים. יש לעדכן שוב את האורחים בפרטים החדשים.</p>
              <div className="rsvp-option-modal__actions">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowEventDetailsChangeWarning(false)}
                >
                  ביטול
                </button>
                <button type="button" className="btn btn-danger" onClick={confirmEventDetailsChange}>
                  להמשיך
                </button>
              </div>
            </section>
          </div>
        )}

        {showShareLinkModal && <InvitationShareNotice docID={docID} invitationLinkVersion={invitationLinkVersion} addAlertText={addAlertText} setShowShareLinkModal={setShowShareLinkModal} showShareExplanation={showShareExplanation} setShowShareExplanation={setShowShareExplanation} />}

        {showContentHelpModal && (
          <div
            className="content-help-modal-backdrop"
            onMouseDown={(event) => {
              if (event.target === event.currentTarget) setShowContentHelpModal(false);
            }}
          >
            <section
              className="content-help-modal-box"
              role="dialog"
              aria-modal="true"
              aria-labelledby="content-help-modal-title"
            >
              <button
                type="button"
                className="content-help-modal-close"
                aria-label="סגירה"
                onClick={() => setShowContentHelpModal(false)}
              >
                ×
              </button>
              <h2 id="content-help-modal-title">עשיתם טעות בפרטי ההזמנה שבתוך התמונה?</h2>
              <p className="content-help-modal-intro">
                במידה ועשיתם טעות בהזמנה ותרצו לשנות, ניתן לבצע שינוי פעם אחת ללא עלות בצורה הבאה:
              </p>
              <ol className="content-help-modal-steps">
                <li>
                  נכנסים ללינק הזה עם <strong>אותו מכשיר ודפדפן</strong> שביצעתם את ההזמנה:{" "}
                  <a href="https://www.flashback.co.il/he/300-2/" target="_blank" rel="noopener noreferrer">
                    הזמנה לאירוע
                  </a>
                </li>
                <li>תגיעו ישירות לעיצוב ההזמנה האחרונה שלכם — במידה ולא תראו את ההזמנה, סימן שלא נכנסתם עם <strong>אותו מכשיר ודפדפן</strong>.</li>
                <li>עורכים ומתקנים ומוודאים הפעם שכל פרטי ההזמנה תקינים.</li>
                <li>לוחצים על הורדה ומגיעים לדף התשלום, אבל לא לשלם שוב!</li>
                <li>
                  נכנסים לכתובת הזאת עם אותו הדפדפן שערכתם את ההזמנה:{" "}
                  <a
                    href="https://www.flashback.co.il/he/%d7%a0%d7%a1%d7%99%d7%95%d7%9f-%d7%93%d7%a3-%d7%aa%d7%95%d7%93%d7%94/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    הורדת הזמנה חדשה
                  </a>
                </li>
                <li>מורידים את ההזמנה החדשה מהמייל.</li>
                <li>מעלים מחדש את ההזמנה לכאן ב״כפתור החלפת קובץ הכחול״.</li>
              </ol>
              <p className="content-help-modal-footer">נשמח לעמוד לרשותכם בכל שאלה.</p>
            </section>
          </div>
        )}
      </main>
    );
  }

  return (
    <div
      className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 rounded d-flex flex-column greyBlue position-relative justify-content-center align-items-center "
      style={{ borderLeft: `10px solid ${borderColor}`, borderRight: `10px solid ${borderColor}`, backgroundColor: backgroundColor, overflowX: "hidden" }}
    >
      <PreviewBtn isPreview={previewMode} submit={submit} setPreview={setPreviewMode} setSubmit={setSubmit} isReadOnly={isReadOnly} key="32487u8924374892xnjckvnjkxcnvkxcnv" />
      {showLegacyInvitationFields && <div className="col-11 d-flex flex-row justify-content-center m-2">
        <Controller
          widthSize={false}
          colorController={setBackgroundColor}
          colorValue={backgroundColor}
          key="jasnjknsjnausjnaujnsuasdasdasdasdasfsiaui"
          header={"צבע ההזמנה"}
        />
        <Controller
          widthSize={false}
          colorController={setBorderColor}
          colorValue={borderColor}
          key="jasnjknsjnausjndfdgdgfsdfghsdfghaujnsuiaui"
          header={"צבע שוליים"}
        />
      </div>}
      {/* upload */}
      <Waze withWazeLink={withWazeLink} setWithWazeLink={setWithWazeLink} disabled={previewMode} demoAllow={isReadOnly} />
      {withWazeLink && (
        <div className="waze-address-field col-10 col-md-8">
          <label htmlFor="waze-address">
            הכניסו כתובת ל־WAZE - עיר, רחוב ומספר.
          </label>
          <textarea
            id="waze-address"
            className="form-control text-center"
            disabled={previewMode}
            data-demo-allow={isReadOnly ? "true" : undefined}
            value={locationAddress}
            onChange={(e) => setLocationAddress(e.target.value)}
          />
        </div>
      )}
      <div className="col-10 d-flex flex-column justify-content-center align-items-center  mt-2 position-relative ">
        {attachmentUrl ? (
          <FileDisplay
            source={attachmentUrl}
            localState={attachmentType}
            setSource={removeAttachment}
            withButton={!isReadOnly}
            onChangeFile={() => setShowUploadModal(true)}
          />
        ) : (
          <Uploader
            withFile={false}
            addAlertText={addAlertText}
            key="smmdkmsklkbnklkljsnkldnsklmksdl"
            setExternalSource={setExternalSource}
            externalSource={externalSource}
          />
        )}
      </div>

      {/* ── Upload modal popup ── */}
      {showUploadModal && (
        <div
          className="upload-modal-backdrop"
          onClick={(e) => { if (e.target === e.currentTarget) setShowUploadModal(false); }}
        >
          <div className="upload-modal-box">
            <button
              type="button"
              className="btn-close upload-modal-close"
              onClick={() => setShowUploadModal(false)}
            />
            <div className="text-center fw-bold fs-5 mb-3">בחירת קובץ חדש להזמנה</div>
            <Uploader
              withFile={false}
              addAlertText={addAlertText}
              key="modal-uploader"
              setExternalSource={handleUploadFromModal}
              externalSource={externalSource}
            />
          </div>
        </div>
      )}
      {showLegacyInvitationFields && <>
      {/* marriage info */}
      <div className="col-10 d-flex flex-column justify-content-center align-items-center mt-2 position-relative text-center">
        <hr className="rounded" style={{ width: "80%", backgroundColor: borderColor, height: "5px", opacity: "0.2" }} />
        <Controller
          widthSize={false}
          colorController={setNamesColor}
          colorValue={namesColor}
          sizeController={setNamesFontSize}
          sizeValue={namesFontSize}
          key="jasnjknsjnausjnaujnsuiaui"
          header={"חוגג/חוגגים"}
        />

        <div className="col-10 d-flex flex-row  justify-content-center align-items-center">
          <textarea
            contentEditable={true}
            className="col-12 formItem text-center text-center names text-center"
            onChange={(e) => {
              seteventOwners(`${e.target.value}`);
              return;
            }}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     setNamesCols((prev) => prev + 1);
            //   }
            //   if (e.key === "Backspace") {
            //     if (e.target.rows !== 1) {
            //       setNamesCols((prev) => prev - 1);
            //     }
            //   }
            // }}
            // rows={"2"}
            style={{ color: `${namesColor}`, backgroundColor: "transparent", border: "none", whiteSpace: "pre-wrap", height: "75px" }}
            key="lnsdjknasjkddnajksndjkasndjkasdjkas"
            disabled={previewMode ? true : false}
            id="owners"
            value={eventOwners}
          ></textarea>
        </div>
      </div>
      <div className="col-10 d-flex flex-column justify-content-center align-items-center mt-2">
        <Controller
          widthSize={true}
          colorController={setQuouteColor}
          colorValue={quouteColor}
          sizeController={setQuouteFontSize}
          sizeValue={quouteFontSize}
          key="kmjaklsmklasmklasmklamskl"
          header={"הקדשה לאורחים"}
        />

        <textarea
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     setDedicationCols((prev) => prev + 1);
          //   }
          //   if (e.key === "Backspace") {
          //     if (e.target.rows !== 1) {
          //       setDedicationCols((prev) => prev - 1);
          //     }
          //   }
          // }}
          // rows={"2"}
          contentEditable={true}
          className="col-12 text-center"
          style={{
            color: `${quouteColor}`,
            fontSize: `${parseInt(quouteFontSize) - 5}px`,
            backgroundColor: "transparent",
            border: "none",
            whiteSpace: "pre-wrap",
          }}
          key="lnsdjknasjkddnajksndjkasndjkasadassdjkas"
          disabled={previewMode ? true : false}
          onChange={(e) => {
            setDedicationText(e.target.value);
          }}
          value={dedicationText}
        ></textarea>
      </div>
      {/* date */}
      <div className="col-10 d-flex flex-column justify-content-center align-items-center">
        <Controller
          widthSize={true}
          colorController={setDateColor}
          colorValue={dateColor}
          sizeController={setDateFontSize}
          sizeValue={dateFontSize}
          key="kmjaklsmklasmkldsdsdsdsasmklamskl"
          header={"תאריך"}
        />
        <textarea
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     setDateCols((prev) => prev + 1);
          //   }
          //   if (e.key === "Backspace") {
          //     if (e.target.rows !== 1) {
          //       setDateCols((prev) => prev - 1);
          //     }
          //   }
          // }}
          // rows={"2"}
          contentEditable={true}
          className="col-12 formItem text-center "
          style={{
            color: `${dateColor}`,
            fontSize: `${dateFontSize}px`,
            letterSpacing: "10px",
            backgroundColor: "transparent",
            border: "none",
            whiteSpace: "pre-wrap",
            height: "75px",
          }}
          key="lnsdjknasjkddnajksndjkassadasdasdndjkadsfsdfsdjkas"
          disabled={previewMode ? true : false}
          value={date}
          onChange={(e) => setDate(e.target.value)}
        ></textarea>
        <textarea
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     setDayCols((prev) => prev + 1);
          //   }
          //   if (e.key === "Backspace") {
          //     if (e.target.rows !== 1) {
          //       setDayCols((prev) => prev - 1);
          //     }
          //   }
          // }}
          // rows={"2"}
          contentEditable={true}
          className="col-12 formItem text-center text-center text-center"
          style={{
            color: `${dateColor}`,
            fontSize: `${parseInt(dateFontSize) - 15}px`,
            backgroundColor: "transparent",
            border: "none",
            whiteSpace: "pre-wrap",
          }}
          key="lnsdjknasjkddnajksndjkasdasdasndjkadsfsdfsdfsdjkas"
          disabled={previewMode ? true : false}
          value={day}
          onChange={(e) => setDay(e.target.value)}
        ></textarea>
      </div>
      <div className="col-10 d-flex flex-column justify-content-center align-items-center">
        {/* <Controller
          widthSize={true}
          colorController={setAddressColor}
          colorValue={addressColor}
          sizeController={setAddressFontSize}
          sizeValue={addressFontSize}
          key="kmjaklsmklasmsdfsdfsdfksdfsdfsdfldsdsdsdsasmklamskl"
          header={"מיקום האירוע"}
        /> */}

        <textarea
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     setLoctionNameCols((prev) => prev + 1);
          //   }
          //   if (e.key === "Backspace") {
          //     if (e.target.rows !== 1) {
          //       setLoctionNameCols((prev) => prev - 1);
          //     }
          //   }
          // }}
          // rows={"2"}
          contentEditable={true}
          className="col-12 formItem text-center text-center"
          style={{ color: `${addressColor}`, fontSize: `${addressFontSize}px`, backgroundColor: "transparent", border: "none", whiteSpace: "pre-wrap" }}
          key="lnsdjknasjkddnajksndjkasdasdfsdfsdfsdasdndjkasdjkas"
          disabled={previewMode ? true : false}
          value={locationName}
          onChange={(e) => setLocationName(e.target.value)}
        ></textarea>
        <textarea
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     setLocationAddressCols((prev) => prev + 1);
          //   }
          //   if (e.key === "Backspace") {
          //     if (e.target.rows !== 1) {
          //       setLocationAddressCols((prev) => prev - 1);
          //     }
          //   }
          // }}
          // rows={"2"}
          contentEditable={true}
          className="col-12 formItem text-center text-center"
          style={{ color: `${addressColor}`, fontSize: `${addressFontSize}px`, backgroundColor: "transparent", border: "none", whiteSpace: "pre-wrap" }}
          key="lnsdjknasjkddnajksndjkasnassdfsdfsdfasdasddjkasdjkas"
          disabled={previewMode ? true : false}
          value={locationAddress}
          onChange={(e) => setLocationAddress(e.target.value)}
        ></textarea>
      </div>
      {/* parents info */}
      <div className="col-10 d-flex flex-column justify-content-center align-items-center mt-3 position-relative">
        {/* <Controller
          widthSize={true}
          header={"ההורים"}
          colorController={setParentsColor}
          colorValue={parentsColor}
          sizeController={setParentsFontSize}
          sizeValue={parentsFontSize}
          key="kmjaklsmasdasdasdklasmsdfsdfsdfkldsdsdsdsasmklamskl"
        /> */}

        <div className="col-12 d-flex flex-row flex-wrap justify-content-center align-items-start" style={{ minHeight: "100px", whiteSpace: "pre-wrap" }}>
          <div className="col-5 d-flex flex-column justify-content-start align-items-center border-start">
            <textarea
              // onKeyDown={(e) => {
              //   if (e.key === "Enter") {
              //     setgroomLabelCols((prev) => prev + 1);
              //   }
              //   if (e.key === "Backspace") {
              //     if (e.target.rows !== 1) {
              //       setgroomLabelCols((prev) => prev - 1);
              //     }
              //   }
              // }}
              // rows={"2"}
              contentEditable={true}
              key="lnsdjknasjkddnajksndjkasdasdasdasndjkasdjkas"
              disabled={previewMode ? true : false}
              className=" greyBlueText text-center"
              style={{
                color: `${parentsColor}`,
                fontSize: `${parseInt(parentsFontSize) + 10}px`,
                backgroundColor: "transparent",
                border: "none",
                whiteSpace: "pre-wrap",
              }}
              value={groomParentsLabel}
              onChange={(e) => setGroomParentsLabel(e.target.value)}
            ></textarea>
            <div className="col-12 d-flex flex-row justify-content-start align-items-center">
              <textarea
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setgroomParentsCols((prev) => prev + 1);
                  }
                  if (e.key === "Backspace") {
                    if (e.target.rows !== 1) {
                      setgroomParentsCols((prev) => prev - 1);
                    }
                  }
                }}
                rows={groomParentsNamesCols}
                contentEditable={true}
                className="col-12 formItem text-center text-center"
                style={{
                  color: `${parentsColor}`,
                  fontSize: `${parseInt(parentsFontSize) - 5}px`,
                  backgroundColor: "transparent",
                  border: "none",
                  whiteSpace: "pre-wrap",
                }}
                key="lnsdjknasjkddnajksndjkaasdasdasdasdsndjkasdjkas"
                disabled={previewMode ? true : false}
                value={groomParentsNames}
                onChange={(e) => setGroomParentsNames(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className="col-5 d-flex flex-column justify-content-start align-items-center">
            <textarea
              // onKeyDown={(e) => {
              //   if (e.key === "Enter") {
              //     setBrideLabelCols((prev) => prev + 1);
              //   }
              //   if (e.key === "Backspace") {
              //     if (e.target.rows !== 1) {
              //       setBrideLabelCols((prev) => prev - 1);
              //     }
              //   }
              // }}
              // rows={"2"}
              contentEditable={true}
              key="zxczxczxcasdasda"
              disabled={previewMode ? true : false}
              className=" greyBlueText text-center"
              style={{
                color: `${parentsColor}`,
                fontSize: `${parseInt(parentsFontSize) + 10}px`,
                backgroundColor: "transparent",
                border: "none",
                whiteSpace: "pre-wrap",
              }}
              value={brideParentsLabel}
              onChange={(e) => setBrideParentsLabel(e.target.value)}
            ></textarea>
            <div className="col-12 d-flex flex-row justify-content-start align-items-center">
              <textarea
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") {
                //     setbrideParentsNamesCols((prev) => prev + 1);
                //   }
                //   if (e.key === "Backspace") {
                //     if (e.target.rows !== 1) {
                //       setbrideParentsNamesCols((prev) => prev - 1);
                //     }
                //   }
                // }}
                // rows={"2"}
                contentEditable={true}
                className="col-12 formItem text-center text-center"
                style={{
                  color: `${parentsColor}`,
                  fontSize: `${parseInt(parentsFontSize) - 5}px`,
                  backgroundColor: "transparent",
                  border: "none",
                  whiteSpace: "pre-wrap",
                }}
                key="lnsdjknasjkddnajksndjkasndasdasdasdjkasdjkas"
                disabled={previewMode ? true : false}
                value={brideParentsNames}
                onChange={(e) => setBrideParentsNames(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 d-flex flex-row justify-content-center align-items-center mt-2">
          <textarea
            contentEditable={true}
            className="col-12 text-center"
            key="lnsdjknasjkddnajkszxczxczxndjkשדגשדגasndjkasdjkas"
            disabled={previewMode ? true : false}
            value={dedicationSecond}
            onChange={(e) => {
              setdedicationSecond(e.target.value);
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
              fontSize: `${parseInt(parentsFontSize) + 10}px`,
              color: `${parentsColor}`,
              whiteSpace: "pre-wrap",
            }}
          ></textarea>
        </div>
      </div>
      </>}

      <PreviewBtn
        submit={submit}
        setPreview={setPreviewMode}
        isPreview={previewMode}
        setSubmit={setSubmit}
        isReadOnly={isReadOnly}
        key="32487u89243asdasdasdasdaf74892xnjckvnjkxcnvkxcnv"
      />
    </div>
  );
};

export default EditInvite;
